import { useCallback, useMemo } from "react";
import { useMediaQuery, useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";
import { useDispatch, useSelector } from "react-redux";
import { actions, selectors } from "../../redux-store";
import {
  DateFilterTypes,
  StatsFilters,
} from "../../redux-store/slices/stats/interfaces";
import { useCurrentMerchantId, useTypedTranslations } from "../../hooks";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridContainer: {
      width: "100%",
      margin: 0,
      padding: "1em 0.6em",
      paddingTop: "0.3em",
    },
    submitButton: {
      height: "100%",
      margin: 0,
    },
  }),
);

export const useCustomDatePickerToolbar = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(() => ({}), []);
  const atomicStyles = useAtomicStyles();

  const [t] = useTypedTranslations();
  const dateFilterType = useSelector(selectors.getStatsDateFilterType);
  const statsFilters = useSelector(selectors.getStatsFilters);
  const merchantId = useCurrentMerchantId();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  const onChangeFilter = useCallback(
    (statsFilter: StatsFilters, value: string | number) => {
      dispatch(
        actions.setStatsDateFilterType({
          dateFilterType: DateFilterTypes.CUSTOM,
          [statsFilter]: value,
        }),
      );
    },
    [dispatch],
  );
  const handleSubmitFilters = useCallback(() => {
    dispatch(
      actions.triggerDevicesSubscribedAndReachedRequest({
        merchantId,
      }),
    );
  }, [dispatch, merchantId]);

  return {
    styles,
    classes,
    atomicStyles,
    t,
    dateFilterType,
    statsFilters,
    onChangeFilter,
    handleSubmitFilters,
    isMobile,
  };
};
